module.exports = __webpack_public_path__ + "img/footer-img-mo.71fbc323.webp";